import React, { useState } from 'react';

import { UiComponent } from 'components';
import Info from './Info';
import Activity from './Activity';
import History from './History';

const TABS = ['회원정보', '활동정보', '참여내역'] as const;
type TabType = (typeof TABS)[number];

function MobileDetail() {
  const [activeTab, setActiveTab] = useState<TabType>('회원정보');

  return (
    <>
      <UiComponent.MobileTabs
        items={TABS}
        value={activeTab}
        onChange={setActiveTab}
      />
      {activeTab === '회원정보' && <Info />}
      {activeTab === '활동정보' && <Activity />}
      {activeTab === '참여내역' && <History />}
    </>
  );
}

export default MobileDetail;
